import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

import Thai from '@/locales/th';
import English from '@/locales/en';

const resources = {
  en: {
    translation: English
  },
  th: {
    translation: Thai
  }
};

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false
    },
    react: {
      bindI18n: 'languageChanged loaded',
      useSuspense: true
    }
  });